import type {
  ApiResponse,
  CollabUgcRecipientTerms,
  CollabUgcRecipientTermsResponse,
} from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

const fetchUgcTerms = async (creatorIdentityIds: string[]): Promise<CollabUgcRecipientTerms[]> => {
  const { data } = await api.get<ApiResponse<CollabUgcRecipientTermsResponse>>(
    '/dashboard/collabs/ugc-terms',
    { params: { creatorIdentityIds: creatorIdentityIds.join(',') } }
  );
  return data.data?.data ?? [];
};

/**
 * What a UGC proposal to each of these creators will grant, answered by the
 * rule the send applies: the modification requests it will freeze and her
 * offer while her badge is active. Keyed on the sorted ids, so the same
 * recipients share one entry whichever step asks.
 */
export const useCollabUgcTermsQuery = (creatorIdentityIds: string[], enabled: boolean) => {
  const ids = [...new Set(creatorIdentityIds)].sort();
  return useQuery<CollabUgcRecipientTerms[], Error>({
    queryKey: ['collab-ugc-terms', ids],
    queryFn: () => fetchUgcTerms(ids),
    enabled: enabled && ids.length > 0,
    staleTime: 60 * 1000,
  });
};
